// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-card {
  display: block;
  overflow: hidden;
  overflow-wrap: break-word;
  position: relative;
  padding: 0;
  text-decoration: none;
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity, background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;
}
:where(.vuetify-styles) .v-card {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-card--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-card--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-card--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-card {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-card:hover > .v-card__overlay {
  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-card:focus-visible > .v-card__overlay {
  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-card:focus > .v-card__overlay {
    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-card--active > .v-card__overlay, :where(.vuetify-styles) .v-card[aria-haspopup=menu][aria-expanded=true] > .v-card__overlay {
  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-card--active:hover > .v-card__overlay, :where(.vuetify-styles) .v-card[aria-haspopup=menu][aria-expanded=true]:hover > .v-card__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));
}
:where(.vuetify-styles) .v-card--active:focus-visible > .v-card__overlay, :where(.vuetify-styles) .v-card[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-card__overlay {
  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
}
@supports not selector(:focus-visible) {
  :where(.vuetify-styles) .v-card--active:focus > .v-card__overlay, :where(.vuetify-styles) .v-card[aria-haspopup=menu][aria-expanded=true]:focus > .v-card__overlay {
    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));
  }
}
:where(.vuetify-styles) .v-card--variant-plain, :where(.vuetify-styles) .v-card--variant-outlined, :where(.vuetify-styles) .v-card--variant-text, :where(.vuetify-styles) .v-card--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-card--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-card--variant-plain:focus, :where(.vuetify-styles) .v-card--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-card--variant-plain .v-card__overlay {
  display: none;
}
:where(.vuetify-styles) .v-card--variant-elevated, :where(.vuetify-styles) .v-card--variant-flat {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-card--variant-elevated {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-card--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-card--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-card--variant-text .v-card__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-card--variant-tonal .v-card__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-card .v-card__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-card--disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
:where(.vuetify-styles) .v-card--disabled > :not(.v-card__loader) {
  opacity: 0.6;
}
:where(.vuetify-styles) .v-card--flat {
  box-shadow: none;
}
:where(.vuetify-styles) .v-card--hover {
  cursor: pointer;
}
:where(.vuetify-styles) .v-card--hover::before, :where(.vuetify-styles) .v-card--hover::after {
  border-radius: inherit;
  bottom: 0;
  content: "";
  display: block;
  left: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: inherit;
}
:where(.vuetify-styles) .v-card--hover::before {
  opacity: 1;
  z-index: -1;
}
:where(.vuetify-styles) .v-card--hover::before {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-card--hover::after {
  z-index: 1;
  opacity: 0;
}
:where(.vuetify-styles) .v-card--hover::after {
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-card--hover:hover::after {
  opacity: 1;
}
:where(.vuetify-styles) .v-card--hover:hover::before {
  opacity: 0;
}
:where(.vuetify-styles) .v-card--hover:hover {
  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-card--link {
  cursor: pointer;
}

:where(.vuetify-styles) .v-card-actions {
  align-items: center;
  display: flex;
  flex: none;
  min-height: 52px;
  padding: 0.5rem;
  gap: 0.5rem;
}

:where(.vuetify-styles) .v-card-item {
  align-items: center;
  display: grid;
  flex: none;
  grid-template-areas: "prepend content append";
  grid-template-columns: max-content auto max-content;
  padding: 0.625rem 1rem;
}
:where(.vuetify-styles) .v-card-item + .v-card-text {
  padding-top: 0;
}
:where(.vuetify-styles) .v-card-item__prepend, :where(.vuetify-styles) .v-card-item__append {
  align-items: center;
  display: flex;
}
:where(.vuetify-styles) .v-card-item__prepend {
  grid-area: prepend;
  padding-inline-end: 0.5rem;
}
:where(.vuetify-styles) .v-card-item__append {
  grid-area: append;
  padding-inline-start: 0.5rem;
}

:where(.vuetify-styles) .v-card-item__content {
  align-self: center;
  grid-area: content;
  overflow: hidden;
}

:where(.vuetify-styles) .v-card-title {
  display: block;
  flex: none;
  font-size: 1.25rem;
  font-weight: 500;
  hyphens: auto;
  letter-spacing: 0.0125em;
  min-width: 0;
  overflow-wrap: normal;
  overflow: hidden;
  padding: 0.5rem 1rem;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
  word-break: normal;
  word-wrap: break-word;
}
:where(.vuetify-styles) .v-card .v-card-title {
  line-height: 1.6;
}
:where(.vuetify-styles) .v-card--density-comfortable .v-card-title {
  line-height: 1.75rem;
}
:where(.vuetify-styles) .v-card--density-compact .v-card-title {
  line-height: 1.55rem;
}
:where(.vuetify-styles) .v-card-item .v-card-title {
  padding: 0;
}
:where(.vuetify-styles) .v-card-title + .v-card-text,
:where(.vuetify-styles) .v-card-title + .v-card-actions {
  padding-top: 0;
}

:where(.vuetify-styles) .v-card-subtitle {
  display: block;
  flex: none;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  opacity: var(--v-card-subtitle-opacity, var(--v-medium-emphasis-opacity));
  overflow: hidden;
  padding: 0 1rem;
  text-overflow: ellipsis;
  text-transform: none;
  white-space: nowrap;
}
:where(.vuetify-styles) .v-card .v-card-subtitle {
  line-height: 1.425;
}
:where(.vuetify-styles) .v-card--density-comfortable .v-card-subtitle {
  line-height: 1.125rem;
}
:where(.vuetify-styles) .v-card--density-compact .v-card-subtitle {
  line-height: 1rem;
}
:where(.vuetify-styles) .v-card-item .v-card-subtitle {
  padding: 0 0 0.25rem;
}

:where(.vuetify-styles) .v-card-text {
  flex: 1 1 auto;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  opacity: var(--v-card-text-opacity, 1);
  padding: 1rem;
  text-transform: none;
}
:where(.vuetify-styles) .v-card .v-card-text {
  line-height: 1.425;
}
:where(.vuetify-styles) .v-card--density-comfortable .v-card-text {
  line-height: 1.2rem;
}
:where(.vuetify-styles) .v-card--density-compact .v-card-text {
  line-height: 1.15rem;
}

:where(.vuetify-styles) .v-card__image {
  display: flex;
  height: 100%;
  flex: 1 1 auto;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

:where(.vuetify-styles) .v-card__content {
  border-radius: inherit;
  overflow: hidden;
  position: relative;
}

:where(.vuetify-styles) .v-card__loader {
  bottom: auto;
  top: 0;
  left: 0;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 1;
}
@media (forced-colors: active) {
  :where(.vuetify-styles) .v-card__loader .v-progress-linear {
    border: none;
  }
}

:where(.vuetify-styles) .v-card__overlay {
  background-color: currentColor;
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-card:not(.v-card--variant-text, .v-card--variant-plain) {
    border: thin solid;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCard/VCard.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,0BAA0B;EAC1B,oDAAoD;EACpD,wDAAwD;EACxD,UAAU;AACZ;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE;IACE,yEAAyE;EAC3E;AACF;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,wGAAwG;AAC1G;AACA;EACE,wGAAwG;AAC1G;AACA;EACE;IACE,wGAAwG;EAC1G;AACF;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,cAAc;EACd,OAAO;EACP,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uOAAuO;AACzO;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,yOAAyO;AAC3O;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,yOAAyO;AAC3O;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,6CAA6C;EAC7C,mDAAmD;EACnD,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,yEAAyE;EACzE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,sCAAsC;EACtC,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,MAAM;EACN,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;EACpB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".v-card {\n  display: block;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  position: relative;\n  padding: 0;\n  text-decoration: none;\n  transition-duration: 0.28s;\n  transition-property: box-shadow, opacity, background;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 0;\n}\n.v-card {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-card--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-card--absolute {\n  position: absolute;\n}\n.v-card--fixed {\n  position: fixed;\n}\n.v-card {\n  border-radius: 4px;\n}\n.v-card:hover > .v-card__overlay {\n  opacity: calc(var(--v-hover-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-card:focus-visible > .v-card__overlay {\n  opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-card:focus > .v-card__overlay {\n    opacity: calc(var(--v-focus-opacity) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-card--active > .v-card__overlay, .v-card[aria-haspopup=menu][aria-expanded=true] > .v-card__overlay {\n  opacity: calc(var(--v-activated-opacity) * var(--v-theme-overlay-multiplier));\n}\n.v-card--active:hover > .v-card__overlay, .v-card[aria-haspopup=menu][aria-expanded=true]:hover > .v-card__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-hover-opacity)) * var(--v-theme-overlay-multiplier));\n}\n.v-card--active:focus-visible > .v-card__overlay, .v-card[aria-haspopup=menu][aria-expanded=true]:focus-visible > .v-card__overlay {\n  opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n}\n@supports not selector(:focus-visible) {\n  .v-card--active:focus > .v-card__overlay, .v-card[aria-haspopup=menu][aria-expanded=true]:focus > .v-card__overlay {\n    opacity: calc((var(--v-activated-opacity) + var(--v-focus-opacity)) * var(--v-theme-overlay-multiplier));\n  }\n}\n.v-card--variant-plain, .v-card--variant-outlined, .v-card--variant-text, .v-card--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-card--variant-plain {\n  opacity: 0.62;\n}\n.v-card--variant-plain:focus, .v-card--variant-plain:hover {\n  opacity: 1;\n}\n.v-card--variant-plain .v-card__overlay {\n  display: none;\n}\n.v-card--variant-elevated, .v-card--variant-flat {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-card--variant-elevated {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-card--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-card--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-card--variant-text .v-card__overlay {\n  background: currentColor;\n}\n.v-card--variant-tonal .v-card__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-card .v-card__underlay {\n  position: absolute;\n}\n.v-card--disabled {\n  pointer-events: none;\n  user-select: none;\n}\n.v-card--disabled > :not(.v-card__loader) {\n  opacity: 0.6;\n}\n.v-card--flat {\n  box-shadow: none;\n}\n.v-card--hover {\n  cursor: pointer;\n}\n.v-card--hover::before, .v-card--hover::after {\n  border-radius: inherit;\n  bottom: 0;\n  content: \"\";\n  display: block;\n  left: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: inherit;\n}\n.v-card--hover::before {\n  opacity: 1;\n  z-index: -1;\n}\n.v-card--hover::before {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-card--hover::after {\n  z-index: 1;\n  opacity: 0;\n}\n.v-card--hover::after {\n  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-card--hover:hover::after {\n  opacity: 1;\n}\n.v-card--hover:hover::before {\n  opacity: 0;\n}\n.v-card--hover:hover {\n  box-shadow: 0px 5px 5px -3px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 8px 10px 1px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 3px 14px 2px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-card--link {\n  cursor: pointer;\n}\n\n.v-card-actions {\n  align-items: center;\n  display: flex;\n  flex: none;\n  min-height: 52px;\n  padding: 0.5rem;\n  gap: 0.5rem;\n}\n\n.v-card-item {\n  align-items: center;\n  display: grid;\n  flex: none;\n  grid-template-areas: \"prepend content append\";\n  grid-template-columns: max-content auto max-content;\n  padding: 0.625rem 1rem;\n}\n.v-card-item + .v-card-text {\n  padding-top: 0;\n}\n.v-card-item__prepend, .v-card-item__append {\n  align-items: center;\n  display: flex;\n}\n.v-card-item__prepend {\n  grid-area: prepend;\n  padding-inline-end: 0.5rem;\n}\n.v-card-item__append {\n  grid-area: append;\n  padding-inline-start: 0.5rem;\n}\n\n.v-card-item__content {\n  align-self: center;\n  grid-area: content;\n  overflow: hidden;\n}\n\n.v-card-title {\n  display: block;\n  flex: none;\n  font-size: 1.25rem;\n  font-weight: 500;\n  hyphens: auto;\n  letter-spacing: 0.0125em;\n  min-width: 0;\n  overflow-wrap: normal;\n  overflow: hidden;\n  padding: 0.5rem 1rem;\n  text-overflow: ellipsis;\n  text-transform: none;\n  white-space: nowrap;\n  word-break: normal;\n  word-wrap: break-word;\n}\n.v-card .v-card-title {\n  line-height: 1.6;\n}\n.v-card--density-comfortable .v-card-title {\n  line-height: 1.75rem;\n}\n.v-card--density-compact .v-card-title {\n  line-height: 1.55rem;\n}\n.v-card-item .v-card-title {\n  padding: 0;\n}\n.v-card-title + .v-card-text,\n.v-card-title + .v-card-actions {\n  padding-top: 0;\n}\n\n.v-card-subtitle {\n  display: block;\n  flex: none;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0.0178571429em;\n  opacity: var(--v-card-subtitle-opacity, var(--v-medium-emphasis-opacity));\n  overflow: hidden;\n  padding: 0 1rem;\n  text-overflow: ellipsis;\n  text-transform: none;\n  white-space: nowrap;\n}\n.v-card .v-card-subtitle {\n  line-height: 1.425;\n}\n.v-card--density-comfortable .v-card-subtitle {\n  line-height: 1.125rem;\n}\n.v-card--density-compact .v-card-subtitle {\n  line-height: 1rem;\n}\n.v-card-item .v-card-subtitle {\n  padding: 0 0 0.25rem;\n}\n\n.v-card-text {\n  flex: 1 1 auto;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0.0178571429em;\n  opacity: var(--v-card-text-opacity, 1);\n  padding: 1rem;\n  text-transform: none;\n}\n.v-card .v-card-text {\n  line-height: 1.425;\n}\n.v-card--density-comfortable .v-card-text {\n  line-height: 1.2rem;\n}\n.v-card--density-compact .v-card-text {\n  line-height: 1.15rem;\n}\n\n.v-card__image {\n  display: flex;\n  height: 100%;\n  flex: 1 1 auto;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -1;\n}\n\n.v-card__content {\n  border-radius: inherit;\n  overflow: hidden;\n  position: relative;\n}\n\n.v-card__loader {\n  bottom: auto;\n  top: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  width: 100%;\n  z-index: 1;\n}\n@media (forced-colors: active) {\n  .v-card__loader .v-progress-linear {\n    border: none;\n  }\n}\n\n.v-card__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n@media (forced-colors: active) {\n  .v-card:not(.v-card--variant-text, .v-card--variant-plain) {\n    border: thin solid;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
